module.exports = __webpack_public_path__ + "img/applets2icon2.d7218182.png";